import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-rij",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-rij.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-rij.component.less",
})
export class PrefixRijComponent extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 12;
    this.characters = ALLOWED_CHARACTERS["rij"];
  }
}
